import React, { Component } from 'react';

import classNames from 'classnames';
import Home from './components/Home';
import Header from './components/layout/Header'
import Sidebar from './components/layout/Sidebar'
import global from './global';
import { observer } from 'mobx-react';

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

const App = observer(class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      theme: 'lightblue'
    };
  }

  componentDidMount() {
    global.init();
    const themes = ["lightblue", "cyan", "teal", "green", "lightgreen", "orange"];
    const secondaryColor = { lightblue: '#014174', cyan: '#004d50', teal: '#006150', green: '#124016', lightgreen: '#244a15', orange: '#501705', purple: '#260a47' };
    document.querySelector("body").style['backgroundColor'] = secondaryColor[this.state.theme];
    setInterval(() => {
      const nextTheme = themes[getRandomInt(themes.length)];
      this.setState({ theme: nextTheme });
      document.querySelector("body").style['backgroundColor'] = secondaryColor[nextTheme];
    }, 10000);
  }


  handleToggleSidebar() {
    global.toggleSidebar();
  }

  render() {
    const { layout } = this.props;
    const hasContainerFluid = this.props.location.pathname === '/portfolio';
    const layoutClass = classNames({ open: global.store.TOGGLE_SIDEBAR });
    const { theme } = this.state;

    return (
      <div className={layoutClass + " " + theme}>
        <Sidebar layout={layout} />
        <div className="wrap">
          <Header theme={theme} />
          {hasContainerFluid ? <div className="container-fluid zoomed-out content">{this.props.children}</div> : (
            <div className="container content">
              {!this.props.children && <Home layout={layout} />}
              {this.props.children}
            </div>
          )}
        </div>
        <label className="sidebar-toggle" onClick={this.handleToggleSidebar}></label>
      </div>
    );
  }
})

export default App;



// WEBPACK FOOTER //
// ./src/App.js